import { LOCAL_STORAGE_KEYS } from '@/utils/shared/constants';
import { readLocalStorageValue, useLocalStorage } from '@mantine/hooks';

// Manage state of desktop sidenav so that it can persist across refreshes and page transitions
export function useSidenavOpenState() {
    // Need to do an explicit read to get the initial value to avoid a flash of the sidenav on page load
    const initialDesktopOpened = readLocalStorageValue<boolean>({
        key: LOCAL_STORAGE_KEYS.SIDENAV_OPEN_STATE,
    });

    const [desktopOpened, setDesktopOpened] = useLocalStorage<boolean>({
        key: LOCAL_STORAGE_KEYS.SIDENAV_OPEN_STATE,
        defaultValue: initialDesktopOpened,
    });

    return [desktopOpened, setDesktopOpened] as const;
}
